/**
 * useSessionCollectionName
 *
 * Returns the current session collection name.
 *
 * Resolution order:
 * 1. URL pathname (on AREA / SITE / COLLECTION pages that include `:collection`)
 * 2. Persisted state via Redux (hydrated from localStorage on startup)
 */
import { useMemo } from 'react';
import { useAppSelector } from '@/store/hooks';
import { useLocation } from '@/routing/hooks';
import { getCollectionNameFromPath } from '@/routing/lib';
import { collectionsSelector } from '@/store/selectors/collections';
import { selectCollectionName } from '@/store/slices/sessionSlice';
export const useSessionCollectionName = () => {
    const { pathname } = useLocation();
    const collections = useAppSelector(collectionsSelector);
    const collectionNames = useMemo(() => collections.map((c) => c.collection), [collections]);
    const collectionFromUrl = getCollectionNameFromPath(pathname, collectionNames);
    // Fallback: read from Redux (hydrated from persisted state on startup)
    const collectionFromPersistedState = useAppSelector(selectCollectionName);
    return collectionFromUrl !== null && collectionFromUrl !== void 0 ? collectionFromUrl : collectionFromPersistedState;
};
